import debug from 'debug';

const log = debug('itp:core:downloads');

export function showFileInNewTab(blob: any, reportName: string) {
  log('showFileInNewTab: fileName=`{%s}`', reportName);

  window.open(URL.createObjectURL(blob));
}

export function showFileInNewWindow(blob: any, reportName: string) {
  // Adapted from: https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/
  const newWindow = window.open('', reportName, 'width=800,height=1200');
  if (newWindow) {
    setTimeout(() => {
      const dataUrl = window.URL.createObjectURL(blob);
      const title = newWindow.document.createElement('title');
      const iframe = newWindow.document.createElement('iframe');

      title.appendChild(document.createTextNode(reportName));
      newWindow.document.head.appendChild(title);

      iframe.setAttribute('src', dataUrl);
      iframe.setAttribute('width', '100%');
      iframe.setAttribute('height', '100%');

      newWindow.document.body.appendChild(iframe);

      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(dataUrl);
      }, 100);
    }, 100);
  } else {
    alert(
      'To display reports, please disable any pop-blockers for this page and try again.'
    );
  }
}
